
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/school-profile-courses",
      function () {
        return require("private-next-pages/school-profile-courses.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/school-profile-courses"])
      });
    }
  